import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as saaActionTypes from '../saaActionTypes';

/**
 * Search SAA hotel location geolocation
 */
const searchSAAHotelLocationGeolocation = function* searchSAAHotelLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        saaActionTypes.SEARCH_SAA_HOTEL_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        saaActionTypes.SEARCH_SAA_HOTEL_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        saaActionTypes.SEARCH_SAA_HOTEL_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: saaActionTypes.SET_SAA_HOTEL_LOCATION_CANDIDATES,
            payload: {
                locationKey: 'hotelLocation',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSAAHotelLocationGeolocation;
